<template>
  <div class='login'>
     <div class='form'>
        <h2 class="h2">Вход в личный кабинет</h2>
        <LoginForm/>
     </div>
  </div>
</template>

<script>
import LoginForm from "./LoginForm.vue";

export default {
  data () {
    return {
    }
  },
  components: {
    LoginForm
  }
}
</script>

<style scoped lang="scss">
  @import '../../css/var';

  .login {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .form {
     max-width: 320px;
  }

  .h2 {
    margin-bottom: 25px;
    text-align: center;
  }
</style>